import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import get from 'lodash-es/get';

import { WindowService } from '@app/utils/window.service';

export interface NativeAppMessageData {
  [key: string]: any;
}

@Injectable()
export class NativeAppService {
  private readonly trueValue = 'true';
  private _isWebView: boolean;

  constructor(private windowService: WindowService) {}

  isWebView(route?: ActivatedRoute): boolean {
    // Memoizes webView so it is only set once per load
    const hasWebViewQueryParam = route?.snapshot?.queryParams?.is_web_view === this.trueValue;
    this._isWebView ??= hasWebViewQueryParam || this.windowService.isMobileWebView();
    return this._isWebView;
  }

  postMessageToWebkitWebView(message: { action: string }) {
    if (get(window, ['webkit', 'messageHandlers', 'callbackHandler', 'postMessage'])) {
      (<any>window).webkit.messageHandlers.callbackHandler.postMessage(message);
    }
  }

  postRfvMessageToWebkitWebView(message: {
    action: string;
    reasonForVisit: string;
    clinicalConceptId: string;
    serviceAreaId: number;
    appointmentTypeIds: string[];
    structuredVisitReasonFallback: boolean;
    routingSessionId: string;
  }) {
    if (get(window, ['webkit', 'messageHandlers', 'callbackHandler', 'postMessage'])) {
      (<any>window).webkit.messageHandlers.callbackHandler.postMessage(message);
    }
  }

  invokeAndroidWindowMethod(method: string, data?: any) {
    if (get(window, ['Android', method])) {
      if (data) {
        (<any>window).Android[method](JSON.stringify(data));
      } else {
        (<any>window).Android[method]();
      }
    }
  }

  invokeAndroidAndiOS(action: string) {
    this.postMessageToWebkitWebView({ action: action });
    this.invokeAndroidWindowMethod(action);
  }

  invokeAndroidAndiOSWithData(action: string, data: NativeAppMessageData) {
    this.postMessageToWebkitWebViewWithData({ action, ...data });
    this.invokeAndroidWindowMethod(action, data);
  }

  postMessageToWebkitWebViewWithData(message: { action: string; [key: string]: any }) {
    if (get(window, ['webkit', 'messageHandlers', 'callbackHandler', 'postMessage'])) {
      (<any>window).webkit.messageHandlers.callbackHandler.postMessage(message);
    }
  }
}

export const NativeAppActions = {
  CLOSE_APP: 'closeApp',
  CLOSE_WEBVIEW: 'closeWebView',
  HIR_AUTHORIZATION_SUCESS: 'hirAuthorizationSuccess',
  SURVEY_FINISHED: 'surveyFinished',
  TASK_FINISHED: 'taskFinished',
  STRUCTURED_REASON_FOR_VISIT_SUBMITTED: 'structuredReasonForVisitSubmitted',

  GO_HEALTH_SURVEY: 'goHealthSurvey',
  GO_HOME: 'goHome',
  GO_BOOK_APPOINTMENT: 'goBookAppointment',
  GO_SELECT_PROVIDER: 'goSelectProvider',
  GO_MEMBERSHIP_SETTINGS: 'goMembershipSettings',
  GO_MESSAGES: 'goMessages',
  GO_GET_CARE_GCN: 'goGetCareGcn',
};
